import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import { DVTJCUVPipelineTableColumGroups } from '@pages/dvtjcuv/edit/DVTJCUVPipelineInputFormNew';

const SettingHideColumnsModal = (props) => {
    const [hideColumns, setHideColumns] = useState({});
    const [allColumns, setAllColumns] = useState([]);

    const [isLoading, setIsLoading] = useState(false)
    const {isShow, inputHideColumns, columns, onClose, onSave} = props

    useEffect(() => {
        if (inputHideColumns) {
            setHideColumns({...inputHideColumns})
        }
        setAllColumns([...columns])
    }, [inputHideColumns, columns]);

    const onChangeHideColumns = (event, columnName) => {
        hideColumns[columnName] = !hideColumns[columnName];
        setHideColumns({...hideColumns})
    }

    const onSelectAll = () => {
        if (Object.keys(hideColumns).length === 0) {
            let selectColumns = {}
            allColumns.forEach(item => {
                selectColumns[item.key] = true
            })
            setHideColumns(selectColumns)
        } else {
            setHideColumns({})
        }
    }

    return (
        <>
            <Modal show={isShow}
                   size={'lg'}
                   onHide={onClose}
                   animation={false}>
                <Modal.Header>
                    <Modal.Title>Settings</Modal.Title>
                    <Button variant='secondary' onClick={onClose}>
                        Close
                    </Button>
                </Modal.Header>
                <form onSubmit={(event) => {
                    event.preventDefault();
                    onSave(hideColumns)
                }}>
                <Modal.Body>
                    <div className='card card-default'>
                        <div className='card-header'>
                            <h3 className='card-title text-bold'>Check vào các columns muốn hiển thị</h3>
                            <div className={"card-tools"}>
                                <Button type='button'
                                        className='btn btn-default'
                                        onClick={() => {
                                            onSelectAll()
                                        }}
                                >
                                    {Object.keys(hideColumns).length === 0 ? "UnCheck All" : "Check All"}
                                </Button>
                            </div>
                        </div>
                        <div className='card-body row'>
                        {DVTJCUVPipelineTableColumGroups.map((gr, gi) => {
                            return <div className='pipeline-info-card card card-default w-100'>
                                <div className='card-header' style={{backgroundColor: gr.color}}>
                                    <h3 className='card-title text-bold'>{gr.title}</h3>
                                </div>
                                <div className='card-body row'>
                                {allColumns.map(item => {
                                    if (item.group !== (gi + 1)) {
                                        return ""
                                    }
                                    
                                    return <div className={"col-sm-4"} key={`checkInputDisplayColumn_${item.key}`}>
                                        <input type="checkbox" name={`isInput${item.key}`}
                                            id={`checkInputDisplayColumn_${item.key}`}
                                            defaultChecked={!hideColumns[item.key]}
                                            checked={!hideColumns[item.key]}
                                            style={{height: 20, width: 20, verticalAlign: 'middle'}}
                                            onChange={event => onChangeHideColumns(event, item.key)}
                                        />
                                        <label id={`checkInputDisplayColumn_${item.key}`} className={"ml-2"}>
                                            {item.label}
                                        </label>
                                    </div>
                                })}
                                </div>
                            </div>
                        })}
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button type='submit'
                            className='btn btn-primary'
                            isLoading={isLoading}
                            disabled={
                                isLoading
                            }
                            // onClick={() => {
                            //     onSave(hideColumns)
                            // }}
                            >
                        <i className='fas fa-save mr-2'/>
                        Save
                    </Button>
                </Modal.Footer>
                </form>
            </Modal>
        </>
    )
}

export default SettingHideColumnsModal;
